import { FC } from "react";
import cx from "classnames";
import dayjs from "dayjs";
import { MiniTable } from "@/components/DataTable";
import Grid from "@/components/Grid";
import Tag from "@/components/Tag";
import { InfoIcon } from "@/components/Icon";
import { InterviewItem, INTERVIEW_STATUS } from "@/fetch/suppliers";
import Card from "@/components/Card";
import styles from "./Interview.module.scss";
import Tooltip from "@/components/Tooltip";

type InterviewCardProps = {
  interview: InterviewItem;
  showStatus: boolean;
};

const Interview: FC<InterviewCardProps> = ({ interview, showStatus }) => {
  const isTimeSet = !Boolean(interview.organized_by_partner);

  const interviewDate = isTimeSet
    ? dayjs(Number(interview.interview_date || 0) * 1000).tz(
        interview.traveller_time_zone
      )
    : dayjs();

  return (
    <Card
      className={cx(styles.container, {
        [styles.inActiveContainer]:
          interview.status === INTERVIEW_STATUS.INACTIVE,
      })}
    >
      <Grid
        container
        spacing="0px"
        columnSpacing="0px"
        rowSpacing="16px"
        className={styles.row}
      >
        <Grid item md={3} xs={6} order={{ md: 1, xs: 1 }}>
          <MiniTable header="Position" value={interview.role || ""} />
        </Grid>
        {isTimeSet ? (
          <>
            <Grid item md={3} xs={6} order={{ md: 2, xs: 3 }}>
              <MiniTable
                header="Date"
                value={interviewDate.format("DD MMM YYYY")}
              />
            </Grid>
            <Grid item md={3} xs={6} order={{ md: 3, xs: 4 }}>
              <MiniTable
                header="Time"
                value={
                  <span>
                    {interviewDate.format("HH:mm")}
                    <Tooltip
                      title={interview?.traveller_time_zone_display || ""}
                    >
                      <span>
                        <InfoIcon
                          variant="outlined"
                          className={styles.infoIcon}
                        />
                      </span>
                    </Tooltip>
                  </span>
                }
              />
            </Grid>
          </>
        ) : (
          <Grid
            item
            md={6}
            xs={6}
            order={{ md: 2, xs: 3 }}
            className={styles.emptyGrid}
          >
            <MiniTable
              header="Date & Time"
              value={
                <span>
                  {"Time set by partner"}
                  <Tooltip
                    title={`Date & time arranged between partner and traveller`}
                  >
                    <span>
                      <InfoIcon
                        variant="outlined"
                        className={styles.infoIcon}
                      />
                    </span>
                  </Tooltip>
                </span>
              }
            />
          </Grid>
        )}

        <Grid
          item
          md={3}
          xs={6}
          order={{ md: 4, xs: 2 }}
          className={styles.emptyGrid}
        >
          <MiniTable header="Method" value={interview.interview_method || ""} />
        </Grid>
        <Grid item md={9} xs={12} order={{ md: 5, xs: 5 }}>
          <MiniTable
            header="Company"
            value={
              <span>
                {interview.partner_name}
                <br />
                {interview.address}
                {/* {!isTimeSet && (
                  <Tooltip
                    title={`Date & time arranged between partner and traveller`}
                  >
                    <span>
                      <InfoIcon
                        variant="outlined"
                        className={styles.infoIcon}
                      />
                    </span>
                  </Tooltip>
                )} */}
              </span>
            }
            className={styles.bottomRow}
          />
        </Grid>
        {showStatus && (
          <Grid
            item
            md={3}
            xs={12}
            className={styles.tagContainer}
            order={{ md: 6, xs: 6 }}
          >
            <Tag
              label={interview.status}
              variant="filled"
              color={
                interview.status === INTERVIEW_STATUS.PLACED ||
                interview.status === INTERVIEW_STATUS.ACTIVE
                  ? "success"
                  : interview.status === INTERVIEW_STATUS.MISSED ||
                    interview.status === INTERVIEW_STATUS.UNSUCCESSFUL
                  ? "warning"
                  : interview.status === INTERVIEW_STATUS.INACTIVE ||
                    interview.status === INTERVIEW_STATUS.NO_SHOW
                  ? "primary"
                  : "error"
              }
              size="small"
              className={styles.tag}
              classes={{ label: styles.tagLabel }}
            />
          </Grid>
        )}
      </Grid>
    </Card>
  );
};

export default Interview;
